export default __webpack_public_path__ + "static/media/sa.52e0b209.png";